export default __webpack_public_path__ + "static/media/Msg.02e09e8a.svg";